import { Formattable } from 'visuris/Data/Entities/Formattable';

export default class BerthReservationShip extends Formattable {
    public id: string = null;
    public berthReservationID: string = null;
    public linkOrganisationShipId: string = null;
    public vesselName: string = null;
    public vesselMMSI: number = null;
    public vesselENI: string = null;
    public vesselIMO: string = null;
    public requiredLength: number = null;
    public requiredWidth: number = null;
    public tonnage: number = null;
    public cones: string = null;
    public adnCargo: string = null;
    public hsCargo: string = null;
    public remark: string = null;
    public adnCargoMessage: string = null;
    public hsCargoMessage: string = null;

    public isDangerous():boolean {
        return this.hsCargo != null || this.cones != null;
    }

    constructor() {
        super();
    }

    protected getFormatters(): any {
        return {};
    }
}